<template>
  <div style="width: 100%; height: 100%;">
    <el-row v-if="showDetailName===''" style="height: 100%; overflow-x: auto; display: flex;">
      <el-col v-for="drawer in data" :key="drawer.name" :span="12" 
        style="flex: 0 0 auto; height: 100%; display: flex;">
        <div style="padding: 5px; border: 3px solid #d7dee7; 
          margin: 10px; border-radius: 15px; 
          flex: 1; display: flex; justify-content: center;">
          <el-col style="padding: 5px;">
            <!-- What 行 -->
            <el-row style="margin-bottom: 5px; display: flex; align-items: center; justify-content: space-between; height: 6.5%; overflow-y: auto;">
              <span style="flex: 1; margin-right: 10px;">
                <span style="color: rgb(144, 147, 153); font-weight: bold;"><u>What</u></span> data to show: {{ drawer.explain['what_explained'] }}
              </span>
              <el-tag type="info">
                {{ drawer.explain.what }}
              </el-tag>
            </el-row>

            <!-- Why 行 -->
            <el-row style="display: flex; align-items: center; justify-content: space-between; height: 6.5%; overflow-y: auto;">
              <span style="flex: 1; margin-right: 10px;">
                <span style="color: rgb(103, 194, 58); font-weight: bold;"><u>Why</u></span> apply metaphor: {{ drawer.explain['why_explained'] }}
              </span>
              <el-tag type="success">
                {{ drawer.explain.why }}
              </el-tag>
            </el-row>

            <div style="display:flex; align-items: center; justify-content: center;">
              <el-button type="primary" @click="showDetailName=drawer.name" plain>Show More Samples of This Kind</el-button>
            </div>
            
            <!-- ImageExplained 组件 -->
            <div style="display: flex; gap: 20px; margin-top: 10px; 
              flex-direction: column; height: 80%">
              <ImageExplained @recommend="recommend"
                style="max-height: 250px;"
                v-for="card in drawer.children.slice(0, 4)"
                :key="card.name + card.how"
                :cardInit="card"
              />
            </div>
          </el-col>

        </div>    
      </el-col>
    </el-row>
    <el-row v-else style="height: 100%; display: flex; flex-direction: column;">
      <el-row :span="2" style="padding: 10px; background-color: rgb(238, 241, 246);">
        <div style="padding-left: 10px;">
            <el-button @click="showDetailName=''" plain size="mini">
            <i class="el-icon-arrow-left"></i>
            Back
            </el-button>
        </div>
      </el-row>
      <el-row style="flex: 0 0 auto; height: 92%; display: flex;">
        <div style="padding: 5px; border: 3px solid #d7dee7; 
          margin: 10px; border-radius: 15px; 
          flex: 1; display: flex; justify-content: center;">
          <el-col style="padding: 5px;">
            <!-- What 行 -->
            <el-row style="margin-bottom: 5px; display: flex; align-items: center; justify-content: space-between; height: 6.5%; overflow-y: auto;">
              <span style="flex: 1; margin-right: 10px;  font-size: 20px;">
                What data to show: {{ currentDrawer.explain['what_explained'] }}
              </span>
              <el-tag type="info">
                {{ currentDrawer.explain.what }}
              </el-tag>
            </el-row>

            <!-- Why 行 -->
            <el-row style="display: flex; align-items: center; justify-content: space-between; height: 6.5%; overflow-y: auto;">
              <span style="flex: 1; margin-right: 10px; font-size: 20px;">
                Why apply metaphor: {{ currentDrawer.explain['why_explained'] }}
              </span>
              <el-tag type="success">
                {{ currentDrawer.explain.why }}
              </el-tag>
            </el-row>

            <!-- ImageExplained 组件 -->
            <div style="margin-top: 10px; height: 84%; overflow-y: auto;">
              <ImageExplained @recommend="recommend"
                style="width: 500px; height: 200px; display: inline-block; margin: 5px;"
                v-for="card in currentDrawer.allChildren"
                :key="card.name + card.how"
                :cardInit="card"
              />
            </div>
          </el-col>
        </div>
      </el-row>
    </el-row>
  </div>
</template>

<!-- <style>
</style> -->

<script>
// import axios from 'axios';
// import * as d3 from 'd3';
import ImageExplained from './ImageExplained.vue';
export default {
    name: 'Drawers',
    components: {
      ImageExplained,
    },
    props: {
      data: {
        type: Array,
        required: true,
      }
    },
    watch: {
    },
    data() {
      return {
        showDetailName: '',
      }
    },
    computed: {
      currentDrawer() {
        return this.data.find(drawer => drawer.name === this.showDetailName);
      },
    },
    methods: {
      recommend(name, cd) {
        console.log(name);
        this.$message({
          message: 'Recommend similar images as ' + name + ' to user',
          type: 'info'
        });
        this.$emit('recommend', name, cd);
      }
    },
    mounted() {
    }
  };
</script>